import { render, staticRenderFns } from "./DetailPOPage.vue?vue&type=template&id=3e4074e4&scoped=true&"
import script from "./DetailPOPage.vue?vue&type=script&lang=js&"
export * from "./DetailPOPage.vue?vue&type=script&lang=js&"
import style0 from "./DetailPOPage.vue?vue&type=style&index=0&id=3e4074e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4074e4",
  null
  
)

export default component.exports